import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  input,
  output,
} from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { TimelineRecordComponent } from './components';
import { TimelineRecord } from './models';
import { TimelineItemType } from '@fdm/api-client';

@Component({
  selector: 'app-timeline',
  imports: [CommonModule, MatButton, MatIcon, TimelineRecordComponent],
  templateUrl: './timeline.component.html',
  styleUrl: './timeline.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TimelineComponent {
  readonly TimelineItemType = TimelineItemType;
  
  public timelineRecords = input.required<TimelineRecord[]>();

  disabled = input<boolean>(false);
  
  haveAccess = input<boolean>(true);

  public createNote = output<void>();

  public deleteNote = output<number | null>();
  
  // send note index to parent
  public editNote = output<number>();

  public download = output<string | undefined>();

  public onDelete(record: TimelineRecord) {
    this.deleteNote.emit(record.noteId ?? null);
  }
}
